import React, { FC } from 'react'
import { PIFPoster } from '@/molecules/PIFPosters/PIFPoster'
import { Project } from '@/services/ProjectsService'

interface ProjectPostersProps {
  projects?: Project[]
}

export const PIFPosters: FC<ProjectPostersProps> = ({ projects }) => {
  return (
    <div className="mt-8 grid grid-cols-1 gap-3 pb-28 md:grid-cols-3 md:gap-4  xl:grid-cols-4 2xl:grid-cols-5">
      {projects?.map((project) => (project.pifEnabled ? <PIFPoster key={project.slug} project={project} /> : null))}
    </div>
  )
}
